/**
 * @deprecated this is calculated in backend.
 */
export default class DistanceUtils {
  static UnitName = {
    KM: 'km',
    METRES: 'm',
  };
  static Units = {
    [DistanceUtils.UnitName.KM]: 6371,
    [DistanceUtils.UnitName.METRES]: 6371000,
  };
  static Decimals = 2;

  static calculate(lat1, lon1, lat2, lon2, unit = DistanceUtils.UnitName.KM) {
    const R = DistanceUtils.Units[unit];

    const dLat = DistanceUtils.toRad(lat2 - lat1);
    const dLon = DistanceUtils.toRad(lon2 - lon1);

    lat1 = DistanceUtils.toRad(lat1);
    lat2 = DistanceUtils.toRad(lat2);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c;

    return d.toFixed(DistanceUtils.Decimals);
  }

  static toRad(number) {
    return (number * Math.PI) / 180;
  }
}
